// Libraries
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

// MUI
import { Typography } from '@mui/material';
import Grid from '@mui/material/Grid';

// Core
import { ResourceTextApplication } from '../../../core/resources';

// Common
import { ADialog, ADialogActions, ADialogContent, ADialogTitle } from '../../../common/dialog';
import { AnnouncementTypeEnum, BovineSex, SalesType } from '../../../interfaces/enums';
import { ICollectWeek } from '../../../interfaces/IAnnouncement';
import { collectWeekString } from '../../announcements/helpers/collectWeek';

export interface ICreatedPreliminaryAnnouncementsDialogProps {
    onClose: () => void;
    mainAnnouncementType: AnnouncementTypeEnum,
    mainAnnouncementCollectWeekStart: ICollectWeek,
    mainAnnouncementCollectWeekEnd: ICollectWeek,
    linkedPurchaseAnnouncementCollectWeekStart: ICollectWeek,
    linkedPurchaseAnnouncementCollectWeekEnd: ICollectWeek
}

export default function CreatedPreliminaryAnnouncementsDialog(
    props: ICreatedPreliminaryAnnouncementsDialogProps
) {
    const { t } = useTranslation<ResourceTextApplication[]>(['AnelmaBovine', 'AnelmaGeneral']);
    const [loading, setLoading] = useState<boolean>(false);

    const getText = () => {
        let res = [];
        let collectWeek = '';

        collectWeek = collectWeekString(
            props.mainAnnouncementCollectWeekStart,
            props.mainAnnouncementCollectWeekEnd);

        if (props.mainAnnouncementType == AnnouncementTypeEnum.PreliminaryBovineSlaughterAnnouncement) {
            res.push(t(`AnelmaBovine:1203`).replace('{0}', collectWeek));
        }
        else if (props.mainAnnouncementType == AnnouncementTypeEnum.PreliminaryBovineIntermediationAnnouncement) {
            res.push(t(`AnelmaBovine:1204`).replace('{0}', collectWeek));
        }

        collectWeek = collectWeekString(
            props.linkedPurchaseAnnouncementCollectWeekStart,
            props.linkedPurchaseAnnouncementCollectWeekEnd);

        res.push(t('AnelmaBovine:1232').replace('{0}', collectWeek));

        return res;
    };

    return (
        <ADialog
            onClose={() => props.onClose()}
            open={true}
        >
            <ADialogTitle >{t(`AnelmaBovine:1215`)}</ADialogTitle>

            <ADialogContent size='sm' >
                <Grid container style={{ paddingLeft: '24px' }}>
                    {
                        getText().map(s => {
                            return (
                                <Typography variant='body1' style={{ paddingBottom: '10px' }}>
                                    {s}
                                </Typography>
                            );
                        })
                    }
                </Grid>
            </ADialogContent >

            <ADialogActions
                buttons={{
                    left: [],
                    right: [
                        {
                            onClick: () => props.onClose(),
                            type: 'cancel',
                            label: t(`AnelmaGeneral:1152`),
                            disabled: loading,
                        },
                    ],
                }}
            />
        </ADialog>
    );
}
